export default "__VITE_ASSET__zgBaINA2__"